/* eslint-disable radix */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-curly-brace-presence */

import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useParams, useHistory, Link } from 'react-router-dom';
import {
  Button,
  Input,
  Loader,
  IconButton,
  Modal,
  InputNumber,
} from 'rsuite';
import {
  MdArrowBack,
  MdAdd,
  MdEdit,
  MdDelete,
  MdDragIndicator,
  MdBook,
} from 'react-icons/md';
import { toast } from 'react-toastify';

import {
  PageContainer,
  MainContent,
  PageHeader,
  Breadcrumb,
  Section,
  FormGroup,
  ModuleCard,
  EmptyState,
  ModalContent,
} from './styles';
import StatusBadge from './components/StatusBadge';
import ConfirmDialog from './components/ConfirmDialog';
import SortableList from './components/SortableList';
import {
  getTreinamentoById,
  getModulos,
  createModulo,
  updateModulo,
  deleteModulo,
  reorderModulos,
} from '../../services/treinamentos';
import EditorModulo from './EditorModulo';
import { handleUrlBannerChange } from './components/utils/utils';

function ListaModulos({showModulos=true, setShowModulos, idTreinamentoModulos, fecharModulos=false}) {
  const id = idTreinamentoModulos;
  // const { id } = useParams();
  const history = useHistory();

  // Estado geral
  const [loading, setLoading] = useState(true);
  const [treinamento, setTreinamento] = useState(null);

  // Módulos
  const [modulos, setModulos] = useState([]);
  const [loadingModulos, setLoadingModulos] = useState(false);

  // Modal de módulo
  const [moduloModal, setModuloModal] = useState({
    open: false,
    editing: null,
  });
  const [moduloForm, setModuloForm] = useState({
    titulo: '',
    tipo: 'aula',
    urlBanner: '',
    notaMinimaAprovacao: 70,
  });
  const [savingModulo, setSavingModulo] = useState(false);

  // Modal de exclusão
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
    titulo: '',
  });
  const [deleting, setDeleting] = useState(false);
  // Modal de edição de módulo
  const [showEditorModulos, setShowEditorModulos] = useState(false);
  const [moduloEditando, setModuloEditando] = useState(null);
  const [urlBannerValid, setUrlBannerValid] = useState(true);
  const [urlValidationMessage, setUrlValidationMessage] = useState('');

  // Carregar dados do treinamento
  const loadTreinamento = useCallback(async () => {
    if (!id){
      setLoading(false);
      return;
    };
    try {
      const data = await getTreinamentoById(id);
      setTreinamento(data);
    } catch {
      toast.error('Erro ao carregar treinamento');
      history.replace('/home/treinamentos');
    } finally {
      setLoading(false);
    }
  }, [id, history]);

  // Carregar módulos
  const loadModulos = useCallback(async () => {
    if (!id){
      setLoading(false);
      return;
    };
    setLoadingModulos(true);
    try {
      const data = await getModulos(id);
      setModulos(data);
    } catch {
      toast.error('Erro ao carregar módulos');
    } finally {
      setLoadingModulos(false);
    }
  }, [id]);

  useEffect(() => {
    loadTreinamento();
    loadModulos();
  }, [loadTreinamento, loadModulos]);

  // Abrir modal de módulo
  const openModuloModal = useCallback((modulo = null) => {
    if (modulo) {
      setModuloForm({
        titulo: modulo.titulo,
        tipo: modulo.tipo,
        urlBanner: modulo.url_banner || '',
        notaMinimaAprovacao: modulo.nota_minima_aprovacao || 70,
      });
      setModuloModal({ open: true, editing: modulo });
    } else {
      setModuloForm({
        titulo: '',
        tipo: 'aula',
        urlBanner: '',
        notaMinimaAprovacao: 70,
      });
      setModuloModal({ open: true, editing: null });
    }
  }, []);

  // Salvar módulo
  const handleSaveModulo = useCallback(async () => {
    if (!moduloForm.titulo.trim()) {
      toast.error('O título do módulo é obrigatório');
      return;
    }

    setSavingModulo(true);
    try {
      const payload = {
        titulo: moduloForm.titulo,
        tipo: moduloForm.tipo,
        url_banner: moduloForm.urlBanner || null,
        nota_minima_aprovacao: moduloForm.tipo === 'quiz' ? moduloForm.notaMinimaAprovacao : null,
      };

      if (moduloModal.editing) {
        await updateModulo(moduloModal.editing.id, payload);
        toast.success('Módulo atualizado!');
      } else {
        await createModulo({
          ...payload,
          id_treinamento: parseInt(id),
          ordem: modulos.length + 1,
        });
        toast.success('Módulo criado!');
      }

      setModuloModal({ open: false, editing: null });
      loadModulos();
    } catch {
      toast.error('Erro ao salvar módulo');
    } finally {
      setSavingModulo(false);
    }
  }, [moduloForm, moduloModal.editing, id, modulos.length, loadModulos]);

  // Excluir módulo
  const handleDeleteModulo = useCallback(async () => {
    if (!deleteModal.id) return;

    setDeleting(true);
    try {
      await deleteModulo(deleteModal.id);
      toast.success('Módulo excluído');
      setDeleteModal({ open: false, id: null, titulo: '' });
      loadModulos();
    } catch {
      toast.error('Erro ao excluir módulo');
    } finally {
      setDeleting(false);
    }
  }, [deleteModal.id, loadModulos]);

  // Reordenar módulos
  const handleReorderModulos = useCallback(async (newModulos) => {
    setModulos(newModulos);
    try {
      const modulosOrdem = newModulos.map((m, index) => ({
        id: m.id,
        ordem: index + 1,
      }));
      await reorderModulos(id, modulosOrdem);
    } catch {
      toast.error('Erro ao reordenar módulos');
      loadModulos();
    }
  }, [id, loadModulos]);

  // Navegar para edição do módulo
  // const handleEditModuloContent = useCallback((modulo) => {
  //   history.replace(`/home/treinamentos/${id}/modulos/${modulo.id}`);
  // }, [history, id]);

  if (loading) {
    return (
      <PageContainer style={{ display: 'block' }}>
        <MainContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Loader size="lg" content="Carregando..." />
        </MainContent>
      </PageContainer>
    );
  }

  const temQuiz = modulos.some((m) => m.tipo === 'quiz');

  return (
     <Section style={{ marginTop: '10px' }}>
     
          <PageHeader>
          <Button appearance="primary" onClick={() => openModuloModal()}>
            <MdAdd style={{ marginRight: 8 }} />
            Adicionar Módulo
          </Button>
        </PageHeader>
          <h2>Módulos ({modulos.length})</h2>

          {loadingModulos ? (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <Loader content="Carregando módulos..." />
            </div>
          ) : modulos.length === 0 ? (
            <EmptyState>
              <MdBook style={{ fontSize: 48 }} />
              <h3>Nenhum módulo</h3>
              <p>Adicione o primeiro módulo ao treinamento</p>
              <Button appearance="primary" onClick={() => openModuloModal()}>
                <MdAdd style={{ marginRight: 8 }} />
                Adicionar Módulo
              </Button>
            </EmptyState>
          ) : (
            <SortableList
              items={modulos}
              onReorder={handleReorderModulos}
              keyExtractor={(item) => item.id}
              renderItem={(modulo, index, isDragging) => (
                <ModuleCard style={{ opacity: isDragging ? 0.5 : 1 }}>
                  <div className="drag-handle">
                    <MdDragIndicator size={20} />
                  </div>

                  <div
                    className="module-info"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                setModuloEditando(modulo);
                setShowEditorModulos(true);
              }}
                  >
                    <h4>
                      {index + 1}. {modulo.titulo}
                      <StatusBadge variant={modulo.tipo}>
                        {modulo.tipo === 'aula' ? 'Aula' : 'Quiz'}
                      </StatusBadge>
                    </h4>
                    <div className="module-meta">
                      {modulo.tipo === 'quiz' && modulo.nota_minima_aprovacao && (
                        <span>Nota mínima: {modulo.nota_minima_aprovacao}%</span>
                      )}
                    </div>
                  </div>

                  <div className="module-actions">
                    <IconButton
                      icon={<MdEdit />}
                      appearance="subtle"
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        openModuloModal(modulo);
                      }}
                    />
                    <IconButton
                      icon={<MdDelete />}
                      appearance="subtle"
                      color="red"
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteModal({
                          open: true,
                          id: modulo.id,
                          titulo: modulo.titulo,
                        });
                      }}
                    />
                  </div>
                  {/* Modal deedição de módulo */} 
                  <EditorModulo
                  setShowModulos={setShowModulos}
                    showEditorModulos={showEditorModulos}
                    setShowEditorModulos={setShowEditorModulos}
                    // onClose={() => setShowEditarTreinamento(false)}
                    idModulo={moduloEditando && moduloEditando.id}
                    idTreinamentoModulos={idTreinamentoModulos}
                  />
                    {/* EditorModulo */}
                </ModuleCard>
              )}
            />
          )}
        {/* </Section> */}
      {/* </MainContent> */}

      {/* Modal de Módulo */}
      <Modal
        open={moduloModal.open}
        onClose={() => setModuloModal({ open: false, editing: null })}
        size="sm"
      >
        <Modal.Header>
          <Modal.Title>
            {moduloModal.editing ? 'Editar Módulo' : 'Novo Módulo'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent>
            <FormGroup>
              <label>Título *</label>
              <Input
                value={moduloForm.titulo}
                onChange={(v) => setModuloForm((f) => ({ ...f, titulo: v }))}
                placeholder="Ex: Introdução à Cozinha"
              />
            </FormGroup>

            <FormGroup>
              <label>Tipo *</label>
              <div className="type-selector">
                <div
                  className={`type-option ${moduloForm.tipo === 'aula' ? 'selected' : ''}`}
                  onClick={() => setModuloForm((f) => ({ ...f, tipo: 'aula' }))}
                >
                  <div className="icon">📖</div>
                  <div className="label">Aula</div>
                </div>
                <div
                style={{pointerEvents: (!temQuiz || (moduloForm.tipo === 'quiz' && moduloModal.editing !== null)) ? 'auto' : 'none', opacity: !temQuiz ? 1 : 0.5}}
                  className={`type-option ${moduloForm.tipo === 'quiz' ? 'selected' : ''}`}
                  onClick={() => setModuloForm((f) => ({ ...f, tipo: 'quiz' }))}
                >
                  <div className="icon">📝</div>
                  <div className="label">{(!temQuiz || (moduloForm.tipo === 'quiz' && moduloModal.editing !== null)) ? 'Quiz' : 'Quiz (indisponível)' }</div>
                  {(temQuiz && !(moduloForm.tipo === 'quiz' && moduloModal.editing !== null)) && <span style={{ color: 'red', fontSize: '12px'}}>Nao é permitido mais de um quiz por treinamento</span>}
                </div>
              </div>
            </FormGroup>

            {moduloForm.tipo === 'quiz' && (
              <FormGroup>
                <label>Nota mínima para aprovação (%)</label>
                <InputNumber
                  value={moduloForm.notaMinimaAprovacao}
                  onChange={(v) => setModuloForm((f) => ({ ...f, notaMinimaAprovacao: v }))}
                  min={0}
                  max={100}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            )}

            <FormGroup>
              <label>URL do Banner (opcional)</label>
              <Input
                value={moduloForm.urlBanner}
                onChange={(v) => {
                  setModuloForm((f) => ({ ...f, urlBanner: v }));
                  handleUrlBannerChange(v, setUrlBannerValid, setUrlValidationMessage);
                }}
                placeholder="https://exemplo.com/imagem-banner.jpg"
              />
              {!urlBannerValid && (
                <div style={{ color: 'red' }}>{urlValidationMessage}</div>
              )}
              {urlBannerValid && moduloForm.urlBanner && (
                <div style={{ marginTop: 8 }}>
                  <img
                    src={moduloForm.urlBanner}
                    alt="Preview do banner"
                    style={{
                      maxWidth: '100%',
                      maxHeight: 150,
                      borderRadius: 8,
                      border: '1px solid #ddd',
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
            </FormGroup>
          </ModalContent>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setModuloModal({ open: false, editing: null })}
            appearance="subtle"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSaveModulo}
            appearance="primary"
            loading={savingModulo}
          >
            {moduloModal.editing ? 'Salvar' : 'Criar Módulo'}
          </Button>
        </Modal.Footer>
        
      </Modal>

      {/* Modal de confirmação de exclusão */}
      <ConfirmDialog
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, id: null, titulo: '' })}
        onConfirm={handleDeleteModulo}
        title="Excluir Módulo"
        message={`Tem certeza que deseja excluir o módulo "${deleteModal.titulo}"? Esta ação não pode ser desfeita.`}
        confirmText="Excluir"
        loading={deleting}
      />
      
    </Section>
  );
}

ListaModulos.propTypes = {
  showModulos: PropTypes.bool.isRequired,
  setShowModulos: PropTypes.func.isRequired,
  idTreinamentoModulos: PropTypes.number.isRequired,
  fecharModulos: PropTypes.func.isRequired,
};

export default ListaModulos;
